class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this._hoverCloseTimer = null;
    this._hoverOpenTimer = null;
    this._hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.openOnHover = this.openOnHover.bind(this);
    this.closeOnHover = this.closeOnHover.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);

    this.bindHoverEvents();
    this._hoverMedia.addEventListener('change', () => this.bindHoverEvents());
  }

  bindHoverEvents() {
    this.removeEventListener('mouseenter', this.openOnHover);
    this.removeEventListener('mouseleave', this.closeOnHover);
    this.summary.removeEventListener('click', this.onSummaryClick);

    if (!this._hoverMedia.matches) return;

    this.addEventListener('mouseenter', this.openOnHover);
    this.addEventListener('mouseleave', this.closeOnHover);
    this.summary.addEventListener('click', this.onSummaryClick);
  }

  onSummaryClick(event) {
    // Hover already opens the menu; prevent click from immediately closing it
    event.preventDefault();
  }

  openOnHover() {
    window.clearTimeout(this._hoverCloseTimer);
    window.clearTimeout(this._hoverOpenTimer);

    this._hoverOpenTimer = window.setTimeout(() => {
      document.querySelectorAll('header-menu details[open]').forEach((details) => {
        if (details !== this.mainDetailsToggle) {
          details.removeAttribute('open');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
      });

      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
      this.onToggle();
    }, 60);
  }

  closeOnHover() {
    window.clearTimeout(this._hoverOpenTimer);
    window.clearTimeout(this._hoverCloseTimer);
    this._hoverCloseTimer = window.setTimeout(() => {
      this.close();
      this.onToggle();
    }, 180);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
